
export default {
  selectTextList: { // 웹모바일 텍스트 조회
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/common/selectTextList'
  },
  selectMobileMenu: { // 메뉴 조회
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/common/selectMobileMenu'
  },
  selectMobileInfo: { // 웹모바일 기본정보 조회
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/common/selectMobileInfo'
  },
  selectCategoryMenu: { // 카테고리 메뉴 조회
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/common/selectCategoryMenu'
  },
  selectCategoryMenuDepth: { // 카테고리 메뉴 조회(뎁스)
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/common/selectCategoryMenuDepth'
  },
  selectNewAlarmList: { // 신규 알림 목록 조회
    method: 'GET',
    url: 'mrm/v1/permit/common/selectNewAlarmList',
    showSpinner: false // 스피너 OFF
  },
  updateNewAlarmRead: { // 알람 확인 정보 갱신
    method: 'POST',
    url: 'mrm/v1/permit/nrw/student/alarmRead'
  },
  uploadFile: { // 파일 업로드
    method: 'POST',
    url: 'mrm/v1/permit/nrw/upload/file', // 'mrm/v1/mobile/upload/file',
    upload: true // Multipart 전송시
  },
  downloadFile: { // 파일 다운로드
    method: 'GET',
    url: 'mrm/v1/permit/nrw/download/file' // 'mrm/v1/mobile/download/file'
  },
  downloadImage: { // 이미지 다운로드
    method: 'GET',
    url: 'mrm/v1/permit/nrw/download/image'
  },
  confirmAttachFile: { // 수강신청 - 첨부파일 저장 api
    method: 'POST',
    url: 'mrm/v1/permit/nrw/student/enrolment/confirmAttachFile' // 'mrm/v1/student/enrolment/confirmAttachFile'
  },
  selectAttachFile: { // 수강신청 - 첨부파일 저장 api
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/common/selectAttachFile'
  }

}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/commonApi.js